import { useState, useCallback, useEffect } from 'react';
import { winnreNoAuth, winnreAuth } from '../../utils/axios';
import qs from 'qs';
import { authActions } from '../../store/auth-slice';
import { useDispatch } from 'react-redux';
import { usePhoneInput, useInput } from '../../Hooks';
import { getConfig } from '../../utils/config';
import { useHistory, useLocation } from 'react-router';
import { checkRole } from '../../helpers';
import { RE_EMAIL } from '../../constants';

let interval = null;

export const useData = (selectedOption) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const postLoginUrl = queryParams.get('postLoginUrl')
        ? queryParams.get('postLoginUrl')
        : '';
    const history = useHistory();
    const config = getConfig();
    const [createRegistration, setCreateRegistration] = useState(false);

    const {
        state: {
            isValid: mobileNumberIsValid,
            mobile,
            country,
            mobileHasError,
            isInputFocused,
            isInternationalCustomer
        },
        onChange,
        validator,
        setIsTouched,
        setMobile,
        getMobileWithoutCountryCode,
        setInputFocused,
        setIsInternationalCustomer
    } = usePhoneInput();

    const {
        value: OTP,
        isValid: OTPIsValid,
        hasError: OTPHasError,
        valueChangeHandler: OTPChangedHandler,
        inputBlurHandler: OTPBlurHandler,
        reset: resetOTP
    } = useInput((value) => value !== '');
    const {
        value: email,
        isValid: emailIsValid,
        hasError: emailHasError,
        valueChangeHandler: emailChangedHandler,
        inputBlurHandler: emailBlurHandler,
        reset: resetEmail
    } = useInput((value) => RE_EMAIL.test(value));

    const dispatch = useDispatch();

    const [token, setToken] = useState(null);
    const [sendOtpLoading, setSendOtpLoading] = useState(false);
    const [loginLoading, setLoginLoading] = useState(false);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [timeLeftToResend, setTimeLeftToResend] = useState(0);
    const [isOTPGenerated, setIsOtpGenerated] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [loginWithEmail, setLoginWithEmail] = useState(false);

    const startTimer = useCallback(() => {
        interval = setInterval(() => {
            if (timeLeftToResend >= 1) {
                setTimeLeftToResend((prevState) => prevState - 1);
            } else if (timeLeftToResend < 1) {
                setTimeLeftToResend(0);
            }
        }, 1000);
    }, [timeLeftToResend]);

    useEffect(() => {
        if (timeLeftToResend < 1 && interval) {
            clearInterval(interval);
        }
        if (timeLeftToResend === 59) {
            if (interval) {
                clearInterval(interval);
            }
            startTimer();
        }
    }, [timeLeftToResend]);

    useEffect(() => {
        if (interval && !isOtpSent) {
            clearInterval(interval);
        }
    }, [isOtpSent]);

    const headers2 = {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
        Authorization: `Bearer ${token}`
    };

    const authenticateHandler = (e) => {
        e.preventDefault();

        const data = {
            password: OTP
        };

        setLoginLoading(true);
        winnreNoAuth
            .post('/winnre/login/authenticate', qs.stringify(data), {
                headers: headers2
            })
            .then((res) => {
                console.log('USER', res);
                setLoginLoading(false);
                // console.log('LOGIN RES', res);
                if (res.status === 'FAILED') {
                    setSendOtpLoading(false);
                    setShowErrorAlert(true);
                    setAlertMessage(res.message);
                    // setLoginLoading(false);
                    return;
                }
                resetOTP();
                // setMobile('+91');
                resetEmail();
                setIsTouched(false);
                const cpStatus = res?.user?.cpMaster ? res?.user?.cpMaster?.status : res?.user?.status;
                if (
                    config?.name === 'Brigade' &&
                    ['SALES'].includes(res.user.priorityRole)
                ) {
                    setShowErrorAlert(true);
                    setAlertMessage(
                        `Sorry, we are unable to find your registration.Contact ${config?.name} admin`
                    );
                } else if (
                    cpStatus === 'REGISTERED' ||
                    cpStatus === 'PENDING_APPROVAL' ||
                    (cpStatus === 'PARTIALLY_APPROVED' &&
                        config?.myProfile?.enablepartiallyapprovedUser === true)
                ) {
                    localStorage.setItem('refreshToken', res.refreshToken);
                    localStorage.setItem('accessToken', res.accessToken);
                    dispatch(authActions.authenticationToken(res.accessToken));
                    // setAuthToken(res.accessToken);
                    dispatch(
                        authActions.setUserData({
                            userDetails: {
                                mobileCountryCode: res?.user?.mobileCountryCode,
                                mobileNumber: res?.user?.mobileNumber,
                                email: res?.user?.email,
                                status: cpStatus,
                                preferredName: res?.user?.preferredName,
                                birthDate: res?.user?.dateOfBirth,
                                address: res?.user?.address,
                                companyType: res?.user?.cpMaster?.type
                            },
                            address: res?.user?.address,
                            name: res?.user?.name,
                            userRole: checkRole(res?.user?.eligibleRoles),
                            eligibleRoles: res?.user?.eligibleRoles,
                            userId: res?.user?.id,
                            hashId: res?.user.hashId,
                            profileCompletionPercentage:
                                res?.user?.profileCompletionPercentage,
                            finishedFirstTimeLoginGuide:
                                res?.user?.finishedFirstTimeLoginGuide
                        })
                    );

                    dispatch(authActions.login());
                    dispatch(authActions.closeLoginModal());
                    if (cpStatus === 'REGISTERED') {
                        getUserAccountSummary();
                        if (postLoginUrl) {
                            history.push(postLoginUrl);
                        } else if (config?.myProfile?.enableOverview === true) {
                            history.push('/');

                        } else {
                            history.push('/myProfile/info');
                        }
                    } else if (cpStatus === 'PENDING_APPROVAL') {
                        history.push('/myProfile/docs');
                    }
                } else if (
                    cpStatus === 'AWAITING_DOCUMENTATION' &&
                    selectedOption === 'CHANNEL_PARTNER'
                ) {
                    localStorage.setItem('refreshToken', res.refreshToken);
                    localStorage.setItem('accessToken', res.accessToken);
                    dispatch(authActions.authenticationToken(res.accessToken));
                    // setAuthToken(res.accessToken);
                    dispatch(
                        authActions.setUserData({
                            userDetails: {
                                mobileCountryCode: res?.user?.mobileCountryCode,
                                mobileNumber: res?.user?.mobileNumber,
                                email: res?.user?.email,
                                status: cpStatus,
                                preferredName: res?.user?.preferredName,
                                birthDate: res?.user?.dateOfBirth,
                                address: res?.user?.address,
                                companyType: res?.user?.cpMaster?.type
                            },
                            address: res?.user?.address,
                            name: res?.user?.name,
                            userRole: checkRole(res?.user?.eligibleRoles),
                            eligibleRoles: res?.user?.eligibleRoles,
                            userId: res?.user?.id,
                            hashId: res?.user.hashId,
                            profileCompletionPercentage:
                                res?.user?.profileCompletionPercentage,
                            finishedFirstTimeLoginGuide:
                                res?.user?.finishedFirstTimeLoginGuide
                        })
                    );

                    dispatch(authActions.login());
                    dispatch(authActions.closeLoginModal());
                    if (res?.user?.eligibleRoles.includes('FINANCE', 'SALES')) {
                        history.push('/myProfile/info');
                    } else {
                        history.push('/myProfile/docs');
                    }
                } else if (
                    cpStatus === 'PENDING_APPROVAL' &&
                    selectedOption === 'CHANNEL_PARTNER'
                ) {
                    localStorage.setItem('refreshToken', res.refreshToken);
                    localStorage.setItem('accessToken', res.accessToken);
                    dispatch(authActions.authenticationToken(res.accessToken));
                    // setAuthToken(res.accessToken);
                    dispatch(
                        authActions.setUserData({
                            userDetails: {
                                mobileCountryCode: res?.user?.mobileCountryCode,
                                mobileNumber: res?.user?.mobileNumber,
                                email: res?.user?.email,
                                status: cpStatus,
                                preferredName: res?.user?.preferredName,
                                birthDate: res?.user?.dateOfBirth,
                                address: res?.address,
                                companyType: res?.user?.cpMaster?.type
                            },
                            address: res?.user?.address,
                            name: res?.user?.name,
                            userRole: checkRole(res?.user?.eligibleRoles),
                            eligibleRoles: res?.user?.eligibleRoles,
                            userId: res?.user?.id,
                            hashId: res?.user.hashId,
                            profileCompletionPercentage:
                                res?.user?.profileCompletionPercentage,
                            finishedFirstTimeLoginGuide:
                                res?.user?.finishedFirstTimeLoginGuide
                        })
                    );

                    dispatch(authActions.login());
                    dispatch(authActions.closeLoginModal());
                    if (res?.user?.eligibleRoles.includes('FINANCE', 'SALES')) {
                        history.push('/myProfile/info');
                    } else {
                        history.push('/myProfile/docs');
                    }
                } else if (
                    res?.user?.status === 'NEW_USER' &&
                    selectedOption === 'CHANNEL_PARTNER' &&
                    config?.LOGIN?.SHOW_EMPLOYEE === true
                ) {
                    resetOTP();
                    // setMobile('+91');
                    resetEmail();
                    setIsTouched(false);
                    console.log('emp');
                    sessionStorage.setItem('refreshToken', res.refreshToken);
                    sessionStorage.setItem('accessToken', res.accessToken);
                    sessionStorage.setItem('user', JSON.stringify(res));
                    dispatch(authActions.closeLoginModal());
                    history.push('/empanelment-form');
                    // setMobile(null);
                    // setAuthToken(res.accessToken);
                    dispatch(authActions.authenticationToken(res.accessToken));
                    // setCreateRegistration(true);
                } else if (
                    res?.user?.status === 'NEW_USER' &&
                    selectedOption === 'Site Visitor' &&
                    config?.LOGIN?.SHOW_EMPLOYEE === true
                ) {
                    resetOTP();
                    resetEmail();
                    setIsTouched(false);
                    sessionStorage.setItem('user', JSON.stringify(res));
                    dispatch(authActions.authenticationToken(res.accessToken));
                    setCreateRegistration(true);
                } else if (
                    res?.user?.status === 'NEW_USER' &&
                    selectedOption === 'CHANNEL_PARTNER' &&
                    (config?.showAgreement || config?.loginModal?.Enable_SIGNUP)
                ) {
                    resetOTP();
                    resetEmail();
                    setIsTouched(false);
                    sessionStorage.setItem('user', JSON.stringify(res));
                    dispatch(authActions.authenticationToken(res.accessToken));
                    setCreateRegistration(true);
                } else {
                    console.log(
                        'working',
                        cpStatus,
                        selectedOption,
                        config?.showAgreement,
                        config?.loginModal?.Enable_SIGNUP
                    );
                    setShowErrorAlert(true);
                    setAlertMessage(
                        `Sorry, we are unable to find your registration.Contact ${config?.name} admin`
                    );
                }
            })
            .catch(() => {
                setLoginLoading(false);
                setShowErrorAlert(true);
                setAlertMessage('Something went wrong. Please try again!');
            });
    };

    //Get account summary data
    const getUserAccountSummary = () => {
        winnreAuth({
            method: 'get',
            url: '/winnre/user/booking/account-summary'
        })
            .then((res) => {
                console.log('CALL 1');
                console.log('Account', res);
                dispatch(authActions.setRewardPoints(0));
                dispatch(
                    authActions.setReloyRewardPoints(
                        res?.reloyRewardPoints || 0
                    )
                );
                localStorage.setItem(
                    'reloyRewardPoints',
                    res?.reloyRewardPoints
                );
            })
            .catch((e) => { });
    };

    const getOTP = (e) => {
        setTimeLeftToResend(59);
        if (e) {
            e.preventDefault();
        }
        let data;
        data = {
            userRole: selectedOption,
            ...((selectedOption === 'Employee' ||
                isInternationalCustomer ||
                loginWithEmail) && { email: email }),
            appType: 'WINNRE',
            countryCode: country?.dialCode ? Number(country.dialCode) : '',
            mobile: getMobileWithoutCountryCode()
        };
        let url;
        if (selectedOption === 'Employee' || loginWithEmail) {
            url = '/winnre/login/email?sendOtp=true';
        } else {
            url = 'winnre/login/phone';
        }
        setSendOtpLoading(true);

        winnreNoAuth
            .post(url, qs.stringify(data))
            .then((res) => {
                console.log(res);
                sessionStorage.setItem('user', JSON.stringify(data));
                if (res.status === 'FAILED') {
                    setSendOtpLoading(false);
                    setAlertMessage(res.message);
                    setShowErrorAlert(true);
                    return;
                }
                if (!res.accessToken) {
                    setSendOtpLoading(false);
                    setShowErrorAlert(true);
                    setAlertMessage(
                        'Something went wrong. Try sending OTP again'
                    );
                    return;
                }
                if (res.accessToken) {
                    setToken(res.accessToken);
                }
                setSendOtpLoading(false);
                setIsOtpSent(true);
                setShowSuccessAlert(true);
                setAlertMessage(
                    `The verification code has been sent to the ${isInternationalCustomer ||
                        selectedOption === 'Employee' ||
                        loginWithEmail
                        ? 'email'
                        : 'mobile number'
                    } entered`
                );
            })
            .catch((err) => {
                // console.log(err);
                setSendOtpLoading(false);
                setShowErrorAlert(true);
                setAlertMessage('Something went wrong. Please try again!');
            });
    };

    return {
        state: {
            mobileNumberIsValid,
            mobile,
            country,
            mobileHasError,
            isInputFocused,
            isOtpSent,
            sendOtpLoading,
            OTP,
            OTPHasError,
            OTPIsValid,
            isOTPGenerated,
            loginLoading,
            email,
            emailIsValid,
            emailHasError,
            alertMessage,
            showSuccessAlert,
            showErrorAlert,
            isInternationalCustomer,
            createRegistration,
            timeLeftToResend,
            loginWithEmail
        },
        onChange,
        validator,
        setIsTouched,
        resetEmail,
        getMobileWithoutCountryCode,
        setInputFocused,
        getOTP,
        OTPChangedHandler,
        OTPBlurHandler,
        emailChangedHandler,
        emailBlurHandler,
        authenticateHandler,
        setShowSuccessAlert,
        setShowErrorAlert,
        setAlertMessage,
        setCreateRegistration,
        setMobile,
        setIsInternationalCustomer,
        setIsOtpSent,
        setLoginWithEmail
    };
};
